const indexItems = [
  { letter: 'A', label: '爱情剧', desc: '甜蜜浪漫，心动瞬间', count: '326部' },
  { letter: 'B', label: '爆笑喜剧', desc: '笑到停不下来', count: '218部' },
  { letter: 'C', label: '超级英雄', desc: '正义与力量的碰撞', count: '187部' },
  { letter: 'D', label: '都市情感', desc: '现代人的情感故事', count: '294部' },
  { letter: 'E', label: '儿童动画', desc: '亲子时光最佳选择', count: '156部' },
  { letter: 'F', label: '犯罪悬疑', desc: '烧脑推理层层反转', count: '243部' },
  { letter: 'G', label: '古装历史', desc: '穿越时空的视觉盛宴', count: '312部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              分类索引
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按类型快速找到你想看的内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {indexItems.map((item) => (
              <a
                key={item.label}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group flex items-start gap-4 bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 border border-accent-200 text-lg font-heading font-bold">
                  {item.letter}
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {item.label}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                  <span className="inline-block mt-1 text-xs text-foreground-400">
                    {item.count}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}